import { render, staticRenderFns } from "./VisitaBotoxView.vue?vue&type=template&id=629b1838"
import script from "./VisitaBotoxView.vue?vue&type=script&lang=js"
export * from "./VisitaBotoxView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports